import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export const AccesoModulo = () => {
	const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="403"
      subTitle="Lo sentimos, sin autorización para ingresar a este módulo."
      extra={<Button onClick={() => navigate(-2)} type="primary">Regresar a Home</Button>}
    />
  );
};
